import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import FlexiDivAnnexureCriteria from "./FlexiDivAnnexureCriteria";
import { Neo } from "@singularsystems/neo-react";
import { ReportCategory } from "../ReportCategory";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { IGridLayout } from "@singularsystems/neo-canvas-grid/dist/Grid/Misc/Layouts";
import { Layout } from "@singularsystems/neo-canvas-grid";

@NeoReport("FlexiDivAnnexure", { category: ReportCategory.InvestorReports })
export default class FlexiDivAnnexureReport extends Report<FlexiDivAnnexureCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(FlexiDivAnnexureCriteria);
    }

    public renderCriteria() {
        return (
            <div>
                <DateSelectionComponent criteria={this.criteria} />
                <Neo.GridLayout className="mt-3">
                    <Neo.FormGroupInline bind={this.criteria.meta.investorReferralTypeId} select={{ itemSource: this.dataCache.investorReferralTypes }} />

                </Neo.GridLayout>
            </div>);
    }

    getDefaultGridLayout(criteria: FlexiDivAnnexureCriteria | undefined, propertyKey: string | undefined, data: any): IGridLayout | undefined {
        return {
            "root": {
                "headerLines": 2,
                "columns": [
                    {
                        "key": "rate",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "capitalAmount"
                        }
                    },
                    {
                        "key": "rateNACA",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "capitalAmount"
                        }
                    }
                ]
            }
        } as Layout.IGridLayout;
    }
}